import * as React from "react";
import { InjectRouteParams } from "../../Common/Routing/InjectRouteParams";
import { PermissionRoute } from "../../Common/Routing/PermissionRoute";
import SpecialReportingIndex from "./Special/SpecialReportingIndex";

const RegisterClosureView = React.lazy(() => import("./Closures/RegisterClosureView"));
const AdvancedReports = React.lazy(() => import("./Advanced/AdvancedReports"));
const SalesReports = React.lazy(() => import("./Sales/SalesReports"));
const FavouriteReports = React.lazy(() => import("./Favourites/FavouriteReports"));
const RegisterClosures = React.lazy(() => import("./Closures/RegisterClosures"));
const InventoryReports = React.lazy(() => import("./Inventory/InventoryReports"));
const PurchaseReports = React.lazy(() => import("./Purchases/PurchaseReports"));
const ActionReports = React.lazy(() => import("./Actions/ActionReports"));
const TransferReports = React.lazy(() => import("./Transfers/TransferReports"));
const ReportDashboard = React.lazy(() => import("./Dashboard/ReportDashboard"));
const ReportRevisions = React.lazy(() => import("./Revisions/ReportRevisions"));

export default function ReportingIndex(): Array<React.ReactNode> {
    return [
        <PermissionRoute
            title="Advanced Report | Shopfront"
            permissions={[ "run_advanced_reports" ]}
            path="/reports/advanced"
            key="advanced-report"
            element={<AdvancedReports />}
        />,
        <PermissionRoute
            title="Advanced Report | Shopfront"
            permissions={[ "run_advanced_reports" ]}
            path="/reports/advanced/:id"
            key="advanced-report-with-id"
            element={<AdvancedReports />}
        />,
        <PermissionRoute
            title="Advanced Report | Shopfront"
            permissions={[]}
            path="/reports/:id/revisions"
            key="report-revisions"
            element={<ReportRevisions />}
        />,
        <PermissionRoute
            title="Reporting Dashboard | Shopfront"
            permissions={[ "view_reporting_dashboard" ]}
            path="/reports/dashboard"
            key="report-dashboard"
            element={<ReportDashboard />}
        />,
        <PermissionRoute
            title="Sales Report | Shopfront"
            permissions={[ "run_sales_reports" ]}
            path="/reports/sales"
            key="sales-report"
            element={<SalesReports />}
        />,
        <PermissionRoute
            title="Sales Report | Shopfront"
            permissions={[ "run_sales_reports" ]}
            path="/reports/sales/:id"
            key="sales-report-with-id"
            element={<InjectRouteParams route={SalesReports} />}
        />,
        <PermissionRoute
            title="Inventory Report | Shopfront"
            permissions={[ "run_inventory_reports" ]}
            path="/reports/inventory"
            key="inventory-report"
            element={<InventoryReports />}
        />,
        <PermissionRoute
            title="Inventory Report | Shopfront"
            permissions={[ "run_inventory_reports" ]}
            path="/reports/inventory/:id"
            key="inventory-report-with-id"
            element={<InjectRouteParams route={InventoryReports} />}
        />,
        <PermissionRoute
            title="Purchase Report | Shopfront"
            permissions={[ "run_purchase_reports" ]}
            path="/reports/purchase"
            key="purchase-report"
            element={<PurchaseReports />}
        />,
        <PermissionRoute
            title="Purchase Report | Shopfront"
            permissions={[ "run_purchase_reports" ]}
            path="/reports/purchase/:id"
            key="purchase-report-with-id"
            element={<InjectRouteParams route={PurchaseReports} />}
        />,
        <PermissionRoute
            title="Transfer Report | Shopfront"
            permissions={[ "run_purchase_reports" ]}
            path="/reports/transfer"
            key="transfer-report"
            element={<TransferReports />}
        />,
        <PermissionRoute
            title="Transfer Report | Shopfront"
            permissions={[ "run_purchase_reports" ]}
            path="/reports/transfer/:id"
            key="transfer-report-with-id"
            element={<InjectRouteParams route={TransferReports} />}
        />,
        <PermissionRoute
            title="Actions Report | Shopfront"
            permissions={[ "run_actions_reports" ]}
            path="/reports/actions"
            key="action-report"
            element={<ActionReports />}
        />,
        <PermissionRoute
            title="Actions Report | Shopfront"
            permissions={[ "run_actions_reports" ]}
            path="/reports/actions/:id"
            key="action-report-with-id"
            element={<InjectRouteParams route={ActionReports} />}
        />,
        <PermissionRoute
            title="Favourite Reports | Shopfront"
            oneOf
            permissions={[
                "run_sales_reports",
                "run_inventory_reports",
                "run_purchase_reports",
                "run_advanced_reports",
                "run_actions_reports",
            ]}
            path="/reports/favourites"
            key="favourite-reports"
            element={<FavouriteReports />}
        />,
        <PermissionRoute
            title="Register Closures | Shopfront"
            permissions={[ "view_register_closures", "see_recent_register_closures" ]}
            oneOf
            path="/reports/closures"
            key="register-closures"
            element={<RegisterClosures />}
        />,
        <PermissionRoute
            title="View Register Closure | Shopfront"
            permissions={[ "view_register_closures", "see_recent_register_closures" ]}
            oneOf
            path="/reports/closure/:id"
            key="register-closure-view"
            element={<InjectRouteParams route={RegisterClosureView} />}
        />,
        ...SpecialReportingIndex(),
    ];
}
